import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import alterpressApi from './api';
import { listener } from './listener';
import orderSlice from './slices/order.slice';
import userSlice from './slices/user.slice';
import cartSlice from './slices/cart.slice';
import modalsSlice from './slices/modals.slice';
import accessibilitySlice from './slices/accessibility.slice';
import profileSlice from './slices/profile.slice';

const store = configureStore({
    reducer: {
        [alterpressApi.reducerPath]: alterpressApi.reducer,
        accessibility: accessibilitySlice,
        cart: cartSlice,
        order: orderSlice,
        modals: modalsSlice,
        profile: profileSlice,
        user: userSlice,
    },
    middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware({
            // Ignore error "A non-serializable value was detected in an action" for modals
            serializableCheck: {
                ignoredPaths: ['modals'],
                ignoredActions: ['modals/addModal'],
            },
        })
            .concat(alterpressApi.middleware)
            .prepend(listener.middleware);
    },
});
setupListeners(store.dispatch);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
